import React from 'react';
import { ButtonBase, makeStyles, TableCell, TableRow } from '@material-ui/core';
import { EditIcon, FemaleIcon, MaleIcon, XmaleIcon } from '../../../../../components/Icon';
import admissionUtil from '../../../../../utils/admissionUtil';

const useStyles = makeStyles((theme) => ({
  editBtn: {
    width: '2.25rem',
    height: '2.25rem',
    borderRadius: '8px',
    backgroundColor: '#538FFF',
  },
  editIcon: {
    fontSize: '1.125rem',
    color: '#FFF',
  },
  Male: {
    fontSize: '1rem',
    color: '#538FFF',
  },
  Female: {
    fontSize: '1rem',
    color: '#FF8181',
  },
  Xmale: {
    fontSize: '1.375rem',
    color: '#7B80FF',
  },
  multipleRow: {
    '& .MuiTableCell-root': {
      borderBottom: 'none !important',
    },
  },
}));

const Row = ({
  specialtyId,
  specialtyCode,
  subSpecialtyCode,
  wardAssignBy,
  isActive,
  specialtyWardloc,
  handleEdit,
  codeDesc,
  codeValue,
}) => {
  const classes = useStyles();

  if (specialtyWardloc.length === 0) {
    return (
      <TableRow>
        <TableCell>{specialtyCode}</TableCell>
        <TableCell>{subSpecialtyCode}</TableCell>
        <TableCell>{codeDesc}</TableCell>
        <TableCell>{wardAssignBy}</TableCell>
        <TableCell>{isActive === 1 ? 'Y' : 'N'}</TableCell>
        <TableCell />
        <TableCell />
        <TableCell />
        <TableCell />
        <TableCell />
        <TableCell />
        <TableCell>
          <ButtonBase className={classes.editBtn} onClick={handleEdit}>
            <EditIcon className={classes.editIcon} />
          </ButtonBase>
        </TableCell>
      </TableRow>
    );
  }

  const getAgeDisplay = (item) => {
    if (item?.ageBelow) {
      return `< ${item?.ageBelow}`;
    } else if (item?.ageOnAbove) {
      return `>= ${item?.ageOnAbove}`;
    } else {
      return '';
    }
  };

  return (
    <>
      {specialtyWardloc.map((item, index) => (
        <TableRow
          className={index === specialtyWardloc.length - 1 ? '' : classes.multipleRow}
          key={`${specialtyId}-${item.specialtyWardlocId}`}
        >
          <TableCell>{index === 0 && specialtyCode}</TableCell>
          <TableCell>{index === 0 && subSpecialtyCode}</TableCell>
          <TableCell>{index === 0 && (codeDesc ?? codeValue)}</TableCell>
          <TableCell>{index === 0 && wardAssignBy}</TableCell>
          <TableCell>{index === 0 && (isActive === 1 ? 'Y' : 'N')}</TableCell>
          <TableCell>
            {item.gender === 'M' && <MaleIcon className={classes.Male} />}
            {item.gender === 'F' && <FemaleIcon className={classes.Female} />}
            {item.gender === 'X' && <XmaleIcon className={classes.Xmale} />}
          </TableCell>
          <TableCell>{item.ipasHospCode}</TableCell>
          <TableCell>{item.ipasWardLocation}</TableCell>
          <TableCell>{item.unitName}</TableCell>
          <TableCell>{admissionUtil.initThreshold(item.occThreshold)}</TableCell>
          <TableCell>{getAgeDisplay(item)}</TableCell>
          <TableCell>
            {index === 0 && (
              <ButtonBase className={classes.editBtn} onClick={handleEdit}>
                <EditIcon className={classes.editIcon} />
              </ButtonBase>
            )}
          </TableCell>
        </TableRow>
      ))}
    </>
  );
};

export default Row;
